import dayjs from "dayjs";
import { DATE_FORMAT } from "./date.helper";
import { ContentStatistic } from "../interfaces/ContentStatistic";
import { TypeStatisticsItem } from "../components/types/TypeStatisticItem";
import { ContentTypes } from "../enums/ContentTypes";

class FillMissingDaysHelper {
  private static fillDates<T extends ContentStatistic | TypeStatisticsItem>(
    data: T[],
    startDate: string,
    endDate: string,
    defaultValue: () => Partial<T>
  ): T[] {
    let currentDate = dayjs(startDate);
    const lastDate = dayjs(endDate);
    const completeData: T[] = [];

    while (currentDate <= lastDate) {
      const formattedCurrentDate = currentDate.format(DATE_FORMAT);
      const item = data.find((item) => item.date === formattedCurrentDate);
      completeData.push(
        item ??
          ({
            date: formattedCurrentDate,
            ...defaultValue(),
          } as T)
      );
      currentDate = currentDate.add(1, "day");
    }

    return completeData;
  }

  public static fillMissingContentDates(
    data: ContentStatistic[],
    startDate: string,
    endDate: string
  ): ContentStatistic[] {
    return this.fillDates(data, startDate, endDate, () => ({ count: 0 }));
  }

  public static fillMissingTypeDates(
    data: TypeStatisticsItem[],
    startDate: string,
    endDate: string
  ): TypeStatisticsItem[] {
    return this.fillDates(data, startDate, endDate, () => ({
      [ContentTypes.SPORT]: 0,
      [ContentTypes.GENERIC]: 0,
      [ContentTypes.NEWS]: 0,
      [ContentTypes.OPERATOR]: 0,
      [ContentTypes.TIP]: 0,
    }));
  }
}

export default FillMissingDaysHelper;
